import {BuyBonusPopUpEvents, ReelsEvents, ReelsModule, ReelsViewEvents} from '@gongxigames/framework/slot';
import {GameReelsSpinningState} from 'src/gameReels/states/GameReelsSpinningState';
import {GameReelsView} from 'src/gameReels/GameReelsView';
import {GameReelsInitState} from 'src/gameReels/states/GameReelsInitState';
import {PremonitionModule} from 'src/premonition/PremonitionModule';
import {WolfHavenSpin} from 'com/gongxigames/math/wolfhaven/engine/WolfHavenSpin';
import {GameLogic} from 'src/server/GameLogic';
import {RandomWildEvents} from 'src/randomWild/RandomWildEvents';
import {GameReelsBasicState} from 'src/gameReels/states/GameReelsBasicState';
import {Bonus} from 'com/gongxigames/math/core/game/engine/bonus/Bonus';
import {WolfHaven} from 'com/gongxigames/math/wolfhaven/engine/WolfHaven';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';

export class GameReelsModule extends ReelsModule {
    public init(): void {
        this._states = {};
        this.setupViews();
        this.setupStates();
        this.setupEvents();
        this._reels = WolfHaven.BG_SINGLE_REEL_SET.getReels();
        this.gotoState(ReelsModule.INIT_STATE);
    }

    protected setupEvents(): void {
        super.setupEvents();
        this.onCurrentStateHandle(RandomWildEvents.WILD_LANDED);
        this.onCurrentStateHandle(RandomWildEvents.ACTIVATOR_WIN_STARTED);
        this.onCurrentStateHandle(RandomWildEvents.ACTIVATOR_WIN_FINISHED);
        this.onCurrentStateHandle(RandomWildEvents.RANDOM_WILD_FEATURE_FINISHED);
        this.onCurrentStateHandle(RandomWildEvents.SHOULD_START_DARKENING);
        this.onCurrentStateHandle(PremonitionModule.PREMONITION_FINISHED);
        this.onCurrentStateHandle(BuyBonusPopUpEvents.BUY_BUTTON_CLICKED);
    }

    protected setupStates(): void {
        super.setupStates();
        this.addState(new GameReelsSpinningState(this, ReelsModule.SPINNING_STATE));
        this.addState(new GameReelsInitState(this, ReelsModule.INIT_STATE));
        this.addState(new GameReelsBasicState(this, ReelsModule.BASIC_STATE));
        this.gotoState(ReelsModule.BASIC_STATE);
    }

    protected onScatterHitAnimationPlaying(): void {
        const isInFreeSpins = this.logic.spinData.action === Action.FREESPIN;

        this._scatterHitAnimationsCounter++;

        if (this.view.isQuickStop) {
            return;
        }
        const sound = this.view.soundManager.getSound('scatterhit' + this._scatterHitAnimationsCounter);

        if (sound) {
            sound.volume = isInFreeSpins ? 3 : 1;
            sound.play();
        }
        this.view.scattersNumber--;
    }

    protected onAllReelsStoppedCallback(): void {
        this._isAllReelsStopped = true;

        if (this._isAllReelsStopped && this._isAllAnimationsFinished) {
            this.eventManager.emit(ReelsEvents.ALL_REELS_STOPPED);
            this.currentState.handle(ReelsViewEvents.ALL_REELS_STOPPED);
        }
        this._scatterHitAnimationsCounter = 0;
    }

    protected onAllReelAnimationsFinishedCallback(): void {
        this._isAllAnimationsFinished = true;

        if (this._isAllReelsStopped && this._isAllAnimationsFinished) {
            this.onAllReelsStoppedCallback();
            this.currentState.handle(ReelsViewEvents.ALL_REEL_ANIMATIONS_FINISHED);
        }
    }

    protected restoreReelsetAfterFS(): void {
        const logic = (this.logic as GameLogic);
        const fgBonus = logic.getFreeGames();

        if (fgBonus.isBuyBonus()) {
            this.gotoState(GameReelsModule.INIT_STATE);

            return;
        }
        const spin = logic.getSessionForPickBonusWinningRound(Bonus.FREE_GAMES_BONUS) as WolfHavenSpin;

        this.view.dimensions = spin.getDimension();
        this.view.setupReelStripWithPositions(logic.getReelsBeforeFS(spin).getReels(), spin.reelPositions);
        this.view.updateReelsSymbols();
        this.updateRubyCoinOnRestore(spin);
        this.view.restoreOversizedSymbolsOnSpecialLayer();
    }

    public getDimensions(): number[] {
        return (this.logic.spinData as WolfHavenSpin).getDimension();
    }

    public get view(): GameReelsView {
        return this._view as GameReelsView;
    }
}
